import axios from "axios";
import { baseUrl } from '../config/clientsConfig'

const loginService = {

  loginUser: (loginData) => {
    return axios.post(`${baseUrl}/user/login`, loginData);
  },

    resetPassword: (resetData) => {
    return axios.post(`${baseUrl}/user/reset`, resetData);
  }
};

  export default loginService;